/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppearanceStyle } from './AppearanceStyle';
import {
    AppearanceStyleFromJSON,
    AppearanceStyleFromJSONTyped,
    AppearanceStyleToJSON,
    AppearanceStyleToJSONTyped,
} from './AppearanceStyle';
import type { ColorPaletteId } from './ColorPaletteId';
import {
    ColorPaletteIdFromJSON,
    ColorPaletteIdFromJSONTyped,
    ColorPaletteIdToJSON,
    ColorPaletteIdToJSONTyped,
} from './ColorPaletteId';
import type { ThemeMode } from './ThemeMode';
import {
    ThemeModeFromJSON,
    ThemeModeFromJSONTyped,
    ThemeModeToJSON,
    ThemeModeToJSONTyped,
} from './ThemeMode';
import type { FontSize } from './FontSize';
import {
    FontSizeFromJSON,
    FontSizeFromJSONTyped,
    FontSizeToJSON,
    FontSizeToJSONTyped,
} from './FontSize';
import type { IdNameResultOfint } from './IdNameResultOfint';
import {
    IdNameResultOfintFromJSON,
    IdNameResultOfintFromJSONTyped,
    IdNameResultOfintToJSON,
    IdNameResultOfintToJSONTyped,
} from './IdNameResultOfint';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetTenantResponse
 */
export interface GetTenantResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetTenantResponse
     */
    tenantId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetTenantResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantResponse
     */
    displayName: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTenantResponse
     */
    owner: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTenantResponse
     */
    siteUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTenantResponse
     */
    addressLine1: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTenantResponse
     */
    addressLine2: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTenantResponse
     */
    addressLine3: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTenantResponse
     */
    phoneNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTenantResponse
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTenantResponse
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTenantResponse
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTenantResponse
     */
    currency: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTenantResponse
     */
    timeZone: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTenantResponse
     */
    country: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTenantResponse
     */
    state: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetTenantResponse
     */
    taxRate: number;
    /**
     * 
     * @type {ColorPaletteId}
     * @memberof GetTenantResponse
     */
    colorPaletteId: ColorPaletteId | null;
    /**
     * 
     * @type {AppearanceStyle}
     * @memberof GetTenantResponse
     */
    dashboardAppearance: AppearanceStyle | null;
    /**
     * 
     * @type {string}
     * @memberof GetTenantResponse
     */
    customColor: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetTenantResponse
     */
    grainEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTenantResponse
     */
    gradientEnabled: boolean;
    /**
     * 
     * @type {ThemeMode}
     * @memberof GetTenantResponse
     */
    themeModeControl: ThemeMode | null;
    /**
     * 
     * @type {FontSize}
     * @memberof GetTenantResponse
     */
    fontSize: FontSize | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetTenantResponse
     */
    isPayJunctionEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTenantResponse
     */
    autoPaymentEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTenantResponse
     */
    autoTuitionCalculationEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTenantResponse
     */
    allowChargingFromInvoices: boolean;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof GetTenantResponse
     */
    principalLocation: IdNameResultOfint | null;
}



/**
 * Check if a given object implements the GetTenantResponse interface.
 */
export function instanceOfGetTenantResponse(value: object): value is GetTenantResponse {
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if (!('siteUrl' in value) || value['siteUrl'] === undefined) return false;
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    if (!('addressLine2' in value) || value['addressLine2'] === undefined) return false;
    if (!('addressLine3' in value) || value['addressLine3'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('timeZone' in value) || value['timeZone'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('taxRate' in value) || value['taxRate'] === undefined) return false;
    if (!('colorPaletteId' in value) || value['colorPaletteId'] === undefined) return false;
    if (!('dashboardAppearance' in value) || value['dashboardAppearance'] === undefined) return false;
    if (!('customColor' in value) || value['customColor'] === undefined) return false;
    if (!('grainEnabled' in value) || value['grainEnabled'] === undefined) return false;
    if (!('gradientEnabled' in value) || value['gradientEnabled'] === undefined) return false;
    if (!('themeModeControl' in value) || value['themeModeControl'] === undefined) return false;
    if (!('fontSize' in value) || value['fontSize'] === undefined) return false;
    if (!('isPayJunctionEnabled' in value) || value['isPayJunctionEnabled'] === undefined) return false;
    if (!('autoPaymentEnabled' in value) || value['autoPaymentEnabled'] === undefined) return false;
    if (!('autoTuitionCalculationEnabled' in value) || value['autoTuitionCalculationEnabled'] === undefined) return false;
    if (!('allowChargingFromInvoices' in value) || value['allowChargingFromInvoices'] === undefined) return false;
    if (!('principalLocation' in value) || value['principalLocation'] === undefined) return false;
    return true;
}

export function GetTenantResponseFromJSON(json: any): GetTenantResponse {
    return GetTenantResponseFromJSONTyped(json, false);
}

export function GetTenantResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTenantResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': ApiUserTasksGetPageParameterFromJSON(json['tenantId']),
        'name': json['name'],
        'displayName': json['displayName'],
        'owner': json['owner'],
        'siteUrl': json['siteUrl'],
        'addressLine1': json['addressLine1'],
        'addressLine2': json['addressLine2'],
        'addressLine3': json['addressLine3'],
        'phoneNumber': json['phoneNumber'],
        'email': json['email'],
        'city': json['city'],
        'zipCode': json['zipCode'],
        'currency': json['currency'],
        'timeZone': json['timeZone'],
        'country': json['country'],
        'state': json['state'],
        'taxRate': json['taxRate'],
        'colorPaletteId': ColorPaletteIdFromJSON(json['colorPaletteId']),
        'dashboardAppearance': AppearanceStyleFromJSON(json['dashboardAppearance']),
        'customColor': json['customColor'],
        'grainEnabled': json['grainEnabled'],
        'gradientEnabled': json['gradientEnabled'],
        'themeModeControl': ThemeModeFromJSON(json['themeModeControl']),
        'fontSize': FontSizeFromJSON(json['fontSize']),
        'isPayJunctionEnabled': json['isPayJunctionEnabled'],
        'autoPaymentEnabled': json['autoPaymentEnabled'],
        'autoTuitionCalculationEnabled': json['autoTuitionCalculationEnabled'],
        'allowChargingFromInvoices': json['allowChargingFromInvoices'],
        'principalLocation': IdNameResultOfintFromJSON(json['principalLocation']),
    };
}

export function GetTenantResponseToJSON(json: any): GetTenantResponse {
    return GetTenantResponseToJSONTyped(json, false);
}

export function GetTenantResponseToJSONTyped(value?: GetTenantResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': ApiUserTasksGetPageParameterToJSON(value['tenantId']),
        'name': value['name'],
        'displayName': value['displayName'],
        'owner': value['owner'],
        'siteUrl': value['siteUrl'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'addressLine3': value['addressLine3'],
        'phoneNumber': value['phoneNumber'],
        'email': value['email'],
        'city': value['city'],
        'zipCode': value['zipCode'],
        'currency': value['currency'],
        'timeZone': value['timeZone'],
        'country': value['country'],
        'state': value['state'],
        'taxRate': value['taxRate'],
        'colorPaletteId': ColorPaletteIdToJSON(value['colorPaletteId']),
        'dashboardAppearance': AppearanceStyleToJSON(value['dashboardAppearance']),
        'customColor': value['customColor'],
        'grainEnabled': value['grainEnabled'],
        'gradientEnabled': value['gradientEnabled'],
        'themeModeControl': ThemeModeToJSON(value['themeModeControl']),
        'fontSize': FontSizeToJSON(value['fontSize']),
        'isPayJunctionEnabled': value['isPayJunctionEnabled'],
        'autoPaymentEnabled': value['autoPaymentEnabled'],
        'autoTuitionCalculationEnabled': value['autoTuitionCalculationEnabled'],
        'allowChargingFromInvoices': value['allowChargingFromInvoices'],
        'principalLocation': IdNameResultOfintToJSON(value['principalLocation']),
    };
}

